module.exports = __webpack_public_path__ + "img/page25.77740f4c.gif";